/* Cotton Culture V28 wishlist: one source of truth for collection, PDP and header. */
(function () {
  'use strict';
  var API = 'https://backend.cottonculture.co.in/api/shopifywishlist';
  var customerId = String(window.loggedInCustomerId || window.ShopifyWishlist?.customerId || '').trim();
  var productIds = new Set();
  var busy = new Set();
  var loaded = false;
  var toastTimer;
  var badgeTimer;

  function toId(value) {
    var id = String(value == null ? '' : value).split('/').pop();
    return /^\d+$/.test(id) ? id : '';
  }
  function toast(message, kind) {
    var el = document.getElementById('wishlist-toast');
    if (!el) return;
    clearTimeout(toastTimer);
    el.textContent = message;
    el.classList.remove('hidden');
    el.dataset.kind = kind || 'success';
    el.classList.add('show');
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 3000);
  }
  function paint() {
    document.querySelectorAll('.wishlist-button[data-product-id]').forEach(function (button) {
      var saved = productIds.has(toId(button.dataset.productId));
      button.classList.toggle('wishlist-added', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
      var icon = button.querySelector('.wishlist-icon');
      if (icon) icon.setAttribute('fill', saved ? '#bd1219' : 'none');
      var label = button.querySelector('.cc-pdp-wishlist__label');
      if (label) label.textContent = saved ? 'Saved to wishlist' : 'Save to wishlist';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = String(productIds.size);
      badge.setAttribute('aria-label', productIds.size + ' saved items');
      badge.hidden = !customerId || !loaded; // Show 0 only after a confirmed response.
      var link = badge.closest('.cc-wishlist-header-link, .cc-wishlist-mobile-link');
      if (link && loaded) {
        link.setAttribute('aria-label', 'Wishlist, ' + productIds.size + ' saved ' + (productIds.size === 1 ? 'item' : 'items'));
        link.setAttribute('title', productIds.size + ' saved ' + (productIds.size === 1 ? 'item' : 'items'));
      }
    });
  }
  function readIds(list) {
    return new Set(list.map(function (entry) {
      if (entry && typeof entry === 'object') return toId(entry.product_id || entry.productId || entry.id);
      return toId(entry);
    }).filter(Boolean));
  }
  async function post(endpoint, body) {
    var response = await fetch(API + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Wishlist HTTP ' + response.status);
    return response.json();
  }
  async function refresh() {
    if (!customerId) return;
    try {
      var data = await post('/checkifexist', { customer_id: customerId });
      if (!data || !data.success || !Array.isArray(data.wishlist)) throw new Error('Invalid wishlist response');
      productIds = readIds(data.wishlist);
      loaded = true;
      paint();
    } catch (error) {
      // Do not show an inaccurate badge. Preserve last confirmed state if present.
      if (!loaded) document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) { badge.hidden = true; });
      console.warn('Wishlist could not be refreshed:', error);
    }
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest && event.target.closest('.wishlist-button[data-product-id]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var id = toId(button.dataset.productId);
    if (!id) return;
    if (!customerId) {
      var returnTo = window.location.pathname + window.location.search;
      window.location.assign('/account/login?return_to=' + encodeURIComponent(returnTo));
      return;
    }
    if (busy.has(id)) return;
    busy.add(id);
    document.querySelectorAll('.wishlist-button[data-product-id="' + id + '"]').forEach(function (node) {
      node.disabled = true;
      node.setAttribute('aria-busy', 'true');
      node.classList.add('wishlist-processing');
    });
    try {
      // Existing API toggles an item; wait for its confirmation before updating the count.
      var result = await post('/add', { product_id: Number(id), customer_id: customerId });
      if (!result || !result.success || (result.action !== 'added' && result.action !== 'removed')) {
        throw new Error('Unexpected wishlist update response');
      }
      if (result.action === 'added') productIds.add(id);
      else productIds.delete(id);
      loaded = true;
      paint();
      toast(result.action === 'added' ? 'Saved to your wishlist ✓' : 'Removed from your wishlist');
      document.querySelectorAll('[data-wishlist-count]:not([hidden])').forEach(function (badge) {
        badge.classList.remove('cc-wishlist-count--updated');
        // A reflow allows the confirmation animation to run on repeated saves.
        void badge.offsetWidth;
        badge.classList.add('cc-wishlist-count--updated');
      });
      clearTimeout(badgeTimer);
      badgeTimer = setTimeout(function () {
        document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) { badge.classList.remove('cc-wishlist-count--updated'); });
      }, 360);
      document.dispatchEvent(new CustomEvent('cc:wishlist-changed', { detail: { productId: id, added: result.action === 'added' } }));
    } catch (error) {
      console.error('Wishlist update failed:', error);
      toast('Could not update wishlist. Please try again.', 'error');
    } finally {
      busy.delete(id);
      document.querySelectorAll('.wishlist-button[data-product-id="' + id + '"]').forEach(function (node) {
        node.disabled = false;
        node.removeAttribute('aria-busy');
        node.classList.remove('wishlist-processing');
      });
    }
  });

  // A collection AJAX refresh adds fresh card markup; reuse the confirmed server state.
  document.addEventListener('collection:reloaded', paint);
  document.addEventListener('cc:wishlist-rendered', paint);
  document.addEventListener('cc:wishlist-refresh', refresh);
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); refresh(); }, { once: true });
  } else { paint(); refresh(); }
})();
